import '../scss/cart.scss';
import '../components/discount-codes';
import {
  deleteItem,
  onChangeItemCart,
  openCloseCart,
} from '../components/cart';
import { setQuantity } from '../utils/input-quantity';

openCloseCart();
deleteItem();
setQuantity();
onChangeItemCart();
